/**
 * Collapse accidental `/info/info/` repetition (CMS paths + legacy `/info` prefix rules).
 */
export function collapseDuplicateInfoSegments(path: string): string {
  let out = path;
  while (out.includes('/info/info')) {
    out = out.replace('/info/info', '/info');
  }
  return out;
}

/**
 * Resolves a studio page URL for in-app navigation (header, footer internal links).
 * Paths that are not already app routes get `/info` prefixed for backward compatibility.
 */
export function resolveStudioPageHref(pageUrl: string | undefined): string {
  const rawUrl = pageUrl ?? '/';
  const url = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`;
  if (url === '/') return '/';

  let resolved: string;
  if (
    url.startsWith('/info/') ||
    url === '/info' ||
    url.startsWith('/blogs') ||
    url.startsWith('/recipes') ||
    url.startsWith('/products') ||
    url.startsWith('/product') ||
    url.startsWith('/shops') ||
    url.startsWith('/contact') ||
    url.startsWith('/about-us') ||
    url.startsWith('/account') ||
    url.startsWith('/orders') ||
    url.startsWith('/order') ||
    url.startsWith('/favorites') ||
    url.startsWith('/my-cart') ||
    url.startsWith('/categories')
  ) {
    resolved = url;
  } else {
    resolved = `/info${url}`;
  }

  return collapseDuplicateInfoSegments(resolved);
}
